import { Component, ElementRef } from '@angular/core';
import { NavController, NavParams, ViewController, ActionSheetController, AlertController } from 'ionic-angular';
import { StaffAction } from '../../../actions/staff.action';
import { PhotoAction, _PhotoAction } from '../../../actions/photo.action';
import { AbstractPage } from '../../_com/abstract-page';
import { Subscription } from 'rxjs/Subscription';

/**
 * Generated class for the StaffEditPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-staff-edit',
  templateUrl: 'staff-edit.html',
})
export class StaffEditPage extends AbstractPage{

	data = {};
  captureData$:Subscription;
  photoAction:_PhotoAction;

  constructor(
  	public navCtrl: NavController, 
  	public navParams: NavParams,
  	private viewController:ViewController,
  	private actionSheetController:ActionSheetController,
  	private tmpPhotoAction:PhotoAction,
  	private staffAction:StaffAction,
    private alertController:AlertController,
    private el: ElementRef,
  	) {
    super();

    this.photoAction = this.tmpPhotoAction.getInstance();
    

    this.takePictureDataSubscribe();
    super.readyDomAccess(this.el);
  }

  ionViewDidLoad() {

    if(this.navParams.data){
      delete this.navParams.data["password"];
    	this.data = this.navParams.data;
    }
  }

  /**
   * パスワードリセット
   */
  passwordReset(){

    super.confirm(this.alertController, "パスワードをリセットします。よろしいですか？", ()=>{

      this.staffAction.passwordReset(this.data["user_id"]).subscribe(status=>{

        var msg = (status) ? "パスワードがリセットされました" : "パスワードリセットに失敗しました";
        super.alert(this.alertController, msg);
        this.viewController.dismiss({update:false});
      });
    })
  }

  /**
   * 更新処理
   */
  save(){

    //必須チェック
    if (this.hasInvalidRequired()) {
      this.alert(this.alertController, "未入力の項目を確認してください");
      return;
    }

    this.staffAction.register(this.data).subscribe((data)=>{
      if (data["userStatus"]){
        this.viewController.dismiss({update:true});
      } else {
        this.alert(this.alertController, data["message"]);
      }
    });
  }

  /**
   * キャンセル処理
   */
  cancel(){
    this.viewController.dismiss({update:false});
  }

  /**
   * 写真撮影/アルバム選択
   */
  takePicture(){

  	if(!this.data["id"]){
  		this.alert(this.alertController, "写真の登録は、スタッフ情報を一度保存してから行ってください");
  		return;
    }    
    let actionSheet = this.actionSheetController.create({
      title: '選択してください',
      buttons: [
        {
          text: '写真を撮影する',
          handler: () => this.photoAction.takeCamera({needModal:true, screen:"staff_edit"})
        },{
          text: 'アルバムから選択する',
          handler: () => this.photoAction.photoSelectSingle({needModal:true, screen:"staff_edit"})
        },{
          text: 'キャンセル',
          role: 'cancel'
        }
      ]
    });
    actionSheet.present();
  }

  /**
   * 写真データ取得時イベント
   */
  takePictureDataSubscribe(){

    var self = this;
    
    this.captureData$ = this.photoAction.captureData$.subscribe((imageData)=>{

      if(self.photoAction.getScreen() != "staff_edit") return;

      var updateData = {
        id:this.data["id"],
        imageData:imageData,
      }
      this.staffAction.iconSave(updateData).subscribe((data)=>{
        if(data.data.User){
          delete data.data.User["password"];
          this.data["icon"] = data.data.User["icon"];
          // this.data = data.data.User;
        } else {
          this.alert(this.alertController, "画像登録に失敗しました");
        }
      });
    });
  }


  /**
   * subscription破棄
   */
  ngOnDestroy(){
    this.captureData$.unsubscribe();
    this.photoAction = null;
  }
}


// WEBPACK FOOTER //
// ./src/pages/staff/edit/staff-edit.ts